import { createFileRoute } from '@tanstack/react-router';
import { SetupPage } from '@/features/setup/setup-page';

export const Route = createFileRoute('/_app/w/$workspaceId/setup/')({
    staticData: { crumbs: [{ label: 'shell.crumbSetup' }] },
    component: function SetupRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        return <SetupPage organizationId={organizationId} workspaceId={workspaceId} />;
    },
});
